import React, { useState, useEffect } from "react";
import { sendGetRequest } from '../../../helper/Helper'; 

export default function LeaderBoard() {
  const [month, setMonth] = useState('Current');
  const [current, setCurrent] = useState([]);
  const [previous, setPrevious] = useState([]);
  const [showInfo, setShowInfo] = useState(null);
  const [showInfo2, setShowInfo2] = useState(null);
  useEffect(() => {
    getLeaderData();
  }, [month]);

  const getLeaderData = async () => {
    try {
      const currentResponse = await sendGetRequest('referral/ranking');
      if (currentResponse && currentResponse.status === 200 && currentResponse.data) {
        setCurrent(currentResponse.data); 
      }
    } catch (error) {}

    try {
      const previousResponse = await sendGetRequest('referral/ranking?period=previous');
      if (previousResponse && previousResponse.status === 200 && previousResponse.data) {
        setPrevious(previousResponse.data); 
      }
    } catch (error) {}
  };
  const toggleTransactions = (i) => {
    setShowInfo((prev) => (prev === i ? null : i));
  };
  const toggleTransactions2 = (i) => {
    setShowInfo2((prev) => (prev === i ? null : i));
  };
  return (
    <>
      <div className="gredientBG  subPad SRTOP p-0 overHide " style={{borderRadius:'15px'}}>
      <div className="">
        <div className="dateEco d-flex flex-wrap justify-content-between align-items-center">
          <h2 className="mb-0 speacialH2">PTGC Leaderboard</h2>
          <div className="filter">
            <span className="perVal fInter d-flex align-items-center gap-2 flex-wrap">
              <span>Month:</span>
              <div className="rTabs">
                <button className={month === "Current" ? 'inputrightCenter active': 'inputrightCenter'} onClick={() => setMonth("Current")}>Current</button>
                <button className={month === "Previous" ? 'inputrightCenter active': 'inputrightCenter'} onClick={() => setMonth("Previous")}>Previous</button>
              </div>
            </span>
          </div>
        </div>
      </div>
      <div className="">
        <div className="mt-6">
          <div className="row">
            {
              month === "Current" ?
              current && current.length > 0 ? (
              current.map((item, index) => (
                <div
                  key={index}
                  className="col-sm-12 col-lg-6 borderRight mobBorderBottomAdd991"
                  style={{ borderBottom: "1px solid #ffffff10" }}
                >
                  <div className="EcoSN">
                    <div>
                      <div className="perVal fInter d-flex align-items-center justify-content-between flex-wrap mb-0">
                        <span>{item.referred_username}</span>
                        <span>Rank: {index + 1}</span>
                      </div>
                      {/*  d-flex align-items-center justify-content-between flex-wrap */}
                      <h3 className="dollorValue value mt-2 ">
                        <div className="dollorArea d-flex align-items-center justify-content-between">
                          <div>
                            <span className="val">{parseFloat(item.total_ptgc_amount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                            <span className="dollor2">PTGC</span>
                          </div>
                          <div className="dollorVal mt-0 mb-0">
                            <span className="dollor manageDollor">$</span>
                            <span className="val f28">
                              {parseFloat(item.total_amount).toLocaleString('en-US', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                              })}
                            </span>
                          </div>

                        </div>
                        <div className="mt-2 d-flex justify-content-between flex-wrap gap-1">
                          <span className="wordbreak perVal fInter">{item.referred_wallet}</span>
                          <span className="perVal d-block">Txs: {item.transactions.length}</span>
                        </div>
                      </h3>
                      <div className="perVal fInter d-flex align-items-center flex-wrap mb-0">
                        
                            <button className="borderbtn mybtn px-4 d-flex justify-content-between align-items-center mt-2" onClick={()=>toggleTransactions(index)}><span>{showInfo === index ? "Hide" : "View All"}</span></button>
                      </div>
                    </div>
                    {showInfo === index && (
                    <>
                    <div className="extraContent extraContent1" >
                      <div className="table-responsive">
                      <table>
                        <thead>
                          <tr>
                            <th>Sno.</th>
                            <th>Time</th>
                            <th>Value</th>
                            <th>PTGC</th>
                            <th>Address</th>
                            <th>Txn</th>
                          </tr>
                        </thead>
                        <tbody>
                            {(item.transactions || []).map((itr,idx) => (
                            <>
                              {(itr.timestamp && (
                                
                                
                                <tr>
                                  <td className="fw300">
                                    <div className="white-space">
                                      {idx+1}
                                    </div>
                                  </td>
                                  <td className="fw300">
                                    <div className="white-space">
                                      {itr.timestamp ? itr.timestamp : "-"}
                                    </div>
                                  </td>
  
                                  <td className="fw300">
                                    <div>
                                      {itr.usd_amount 
                                        ? `$${parseFloat(itr.usd_amount).toLocaleString('en-US', {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                          })}`
                                        : "-"
                                      }
                                    </div>
                                  </td>
  
                                  <td className="fw300">
                                    <div>
                                      {itr.ptgc_amount 
                                        ? parseFloat(itr.ptgc_amount).toLocaleString('en-US', {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                          })
                                        : "-"
                                      }
                                    </div>
                                  </td>
  
                                  <td className="fw300">
                                    <div>
                                      {itr.user_address ? itr.user_address : "-"}
                                    </div>
                                  </td>
  
                                  <td className="fw300">
                                    <div>
                                      {itr.transaction_hash ? itr.transaction_hash : "-"}
                                    </div>
                                  </td>
  
                                </tr>
                               
                              ))}
                              {(!itr.timestamp && (
                                <tr>
                                   <td className="fw300">
                                    <div className="white-space">
                                      {idx+1}
                                    </div>
                                  </td>
                                <td className="fw300" colSpan={5}>
                                  <div className="white-space">
                                    Transaction hash not found
                                  </div>
                                </td>

                                

                              </tr>
                              ))}
                            </>
                        ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                    </>
                      )}
                  </div>
                </div>
              ))
            ) : (
              <div className="col-12 text-center p-5">
                <img src="./images/no-data-6.png" className="img-fluid" style={{width: '130px', margin: 'auto'}} /><p>No record found</p>
              </div>
            )
            :
            previous && previous.length > 0 ? (
              previous.map((item, index) => (
              <div
                  key={index}
                  className="col-sm-12 col-lg-6 borderRight mobBorderBottomAdd991"
                  style={{ borderBottom: "1px solid #ffffff10" }}
                >
                  <div className="EcoSN">
                    <div>
                      <div className="perVal fInter d-flex align-items-center justify-content-between flex-wrap mb-0">
                        <span>{item.referred_username}</span>
                        <span>Rank: {index + 1}</span>
                      </div>
                      {/* <h3 className="dollorValue value mt-2">
                        <span className="dollor">$</span>
                        <span className="val">{parseFloat(item.total_amount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 4 })}</span>
                      </h3> */}

                      <h3 className="dollorValue value mt-2 ">
                        <div className="dollorArea d-flex align-items-center justify-content-between">
                          <div>
                            <span className="val">{parseFloat(item.total_ptgc_amount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                            <span className="dollor2">PTGC</span>
                          </div>
                          <div className="dollorVal mt-0 mb-0">
                            <span className="dollor manageDollor">$</span>
                            <span className="val f28">
                              ${parseFloat(item.total_amount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                            </span>
                          </div>

                        </div>
                        <div className="mt-2 d-flex justify-content-between flex-wrap gap-1">
                          <span className="wordbreak perVal fInter">{item.referred_wallet}</span>
                          <span className="perVal d-block">Txs: {item.transactions.length}</span>
                        </div>
                      </h3>
                      
                      <div className="perVal fInter d-flex align-items-center flex-wrap mb-0">
                        
                            <button className="borderbtn mybtn px-4 d-flex justify-content-between align-items-center mt-2" onClick={()=>toggleTransactions2(index)}><span>{showInfo2 === index ? "Hide" : "View All"}</span></button>
                      </div>
                      <div className="perVal fInter d-flex align-items-center flex-wrap mb-0">
                        <span className="wordbreak">{item.referred_wallet}</span>
                      </div>
                    </div>
                    {showInfo2 === index && (

                    <div className="extraContent extraContent1" >
                      <div className="table-responsive">
                      <table>
                        <thead>
                          <tr>
                          <th>Sno.</th>
                            <th>Time</th>
                            <th>Value</th>
                            <th>PTGC</th>
                            <th>Address</th>
                            <th>Txn</th>
                          </tr>
                        </thead>
                        <tbody>
                    {(item.transactions || []).map((itr,idx) => (
                      
                      <>
                      {(itr.timestamp && (
                        
                   
                        <tr>
                           <td className="fw300">
                                    <div className="white-space">
                                      {idx+1}
                                    </div>
                                  </td>
                          <td className="fw300">
                            <div className="white-space">
                              {itr.timestamp ? itr.timestamp : "-"}
                            </div>
                          </td>

                          <td className="fw300">
                            <div>
                              {itr.usd_amount 
                                ? `$${parseFloat(itr.usd_amount).toLocaleString('en-US', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                  })}`
                                : "-"
                              }
                            </div>
                          </td>

                          <td className="fw300">
                            <div>
                              {itr.ptgc_amount 
                                ? parseFloat(itr.ptgc_amount).toLocaleString('en-US', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                  })
                                : "-"
                              }
                            </div>
                          </td>

                          <td className="fw300">
                            <div>
                              {itr.user_address ? itr.user_address : "-"}
                            </div>
                          </td>

                          <td className="fw300">
                            <div>
                              {itr.transaction_hash ? itr.transaction_hash : "-"}
                            </div>
                          </td>

                        </tr>
                      ))}
                      {(!itr.timestamp && (
                        <tr>
                           <td className="fw300">
                                    <div className="white-space">
                                      {idx+1}
                                    </div>
                                  </td>
                        <td className="fw300" colSpan={5}>
                          <div className="white-space">
                            Transaction hash not found
                          </div>
                        </td>

                        

                      </tr>
                      ))}
                    </>

                    ))}
                    </tbody>
                      </table>
                    </div>
                  </div>
                      )}
                  </div>
                </div>
              ))
            ) : (
              <div className="col-12 text-center p-5">
                <img src="./images/no-data-6.png" className="img-fluid" style={{width: '130px', margin: 'auto'}} /><p>No record found</p>
              </div>
            )
          }
        </div>
      </div>
      </div>
    </div>
    </>
  );
}
